/**
 * getMostRecentlyUpdatedModelPageContext
 *
 * Returns the most recently updated model's page context from Redux state.
 * The page context contains pagination parameters (page, size, sort, order)
 * that were active when the model was last updated.
 *
 * Backed by the session RTK Slice.
 *
 * @see src/store/slices/sessionSlice.ts
 */
import { getStore } from '@/store/store-proxy';
import { selectMostRecentlyUpdatedModelPage } from '@/store/slices/sessionSlice';
export const getMostRecentlyUpdatedModelPageContext = () => {
    var _a;
    const state = getStore().getState();
    return (_a = selectMostRecentlyUpdatedModelPage(state)) !== null && _a !== void 0 ? _a : undefined;
};
